export default "__VITE_ASSET__BwyjwcaG__"